import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RecommendationsCampaignsState {
  'explore.affirmations'?: string;
  'explore.couples'?: string;
  'explore.loveLetters'?: string;
  'explore.speakers'?: string;
  'explore.topSoundsForYou'?: string;
  'explore.topStoriesForYou'?: string;
  'home.personalRecommendations'?: string;
  'onboarding.topAudiosForYou'?: string;
  'postPurchase.audiosForYou'?: string;
  'player.similarAudios'?: string;
}

export interface RecommendationsCampaigns {
  [key: string]: string;
}

export const initialCampaignsState: RecommendationsCampaignsState = {
  'explore.affirmations': 'campaign-user-personalization',
  'explore.couples': 'campaign-user-personalization',
  'explore.loveLetters': 'campaign-user-personalization',
  'explore.speakers': 'campaign-user-personalization',
  'explore.topSoundsForYou': 'campaign-user-personalization',
  'explore.topStoriesForYou': 'campaign-user-personalization',
  'home.personalRecommendations': 'campaign-user-personalization',
  'onboarding.topAudiosForYou': 'campaign-personalized-ranking',
  'postPurchase.audiosForYou': 'campaign-personalized-ranking',
  'player.similarAudios': 'campaign-similar-items',
};

const recommendationsCampaignsSlice = createSlice({
  name: 'recommendationsCampaigns',
  initialState: initialCampaignsState,
  reducers: {
    replaceRecommendationsCampaigns: (
      state,
      action: PayloadAction<RecommendationsCampaigns>,
    ) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { replaceRecommendationsCampaigns } =
  recommendationsCampaignsSlice.actions;

export default recommendationsCampaignsSlice.reducer;
